module.exports = __webpack_public_path__ + "img/accountingaccount_create.6eedd650.png";